
@switch (entryType) {
  @case ('char-data') {
    <rl-char-data-element [cmd]="cmd" [editMode]="editMode" [elementUsage]="elementUsage" [formControl]="control"
      [allowEntityFieldEdit]="true" class="d-inline-block">
    </rl-char-data-element>
  }
  @case ('dropdown') {
    @if (editMode) {
      <rl-dropdown-edit-control [selectedValue]="selectedValueIds" [lovs]="lovs"
        (selectedValueChange)="selectedValueChanged($event)" [showEmptyOption]="true" [focused$]="focused$"
        [isMultiple]="false" [isDisabled]="false">
      </rl-dropdown-edit-control>
    }
    @if (!editMode) {
      <span>{{ selectedValuesLabel }}</span>
    }
  }
  @case ('date') {
    @if (editMode) {
      <rl-text-mode-date-input [(ngModel)]="dateValue" (ngModelChange)="dateUpdated()"></rl-text-mode-date-input>
    }
    @if (!editMode) {
      <span>{{ dateValue | localeDate }}</span>
    }
  }
}
